const routes = [
    {
        path: "/coopstudentcertificate",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentcertificate_index"
        }
    }
];

export default routes;
